import { bookmark_primary, profile_circle_primary, refa_logo } from '@assets/icons';
import { PathnameEnum, styleConstant } from '@constant';
import { Box } from '@mui/material';
import { colorSet } from '@theme';
import { useNavigate } from 'react-router';
import { Text } from '../common/Text';
import { useState } from 'react';
import { LogoutPopover } from '../feature/LogoutPopover';

interface IMenuTopProps {
  pageName?: string;
}

export const MenuTop = (props: IMenuTopProps) => {
  const { pageName } = props;

  const [anchorEl, setAnchorEl] = useState<HTMLImageElement | null>(null);

  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate(PathnameEnum.MAIN_PAGE);
  };

  const handleCollectionButtonClick = () => {
    navigate(PathnameEnum.COLLECTION_LIST_PAGE);
  };

  const handlePopoverOpen = (event: React.MouseEvent<HTMLImageElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Box
        style={{
          width: '100%',
          height: styleConstant.menuTopHeight,
          borderBottom: `1px solid ${colorSet.gray200}`,
          backgroundColor: colorSet.white,
          paddingLeft: 40,
          paddingRight: 80,
          display: 'inline-flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          position: 'fixed',
          left: 0,
          right: 0,
          top: 0,
          zIndex: styleConstant.zIndexMenuTop
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <img src={refa_logo} alt="" onClick={handleLogoClick} style={{ cursor: 'pointer' }} />
          {pageName ? (
            <Text variant="h2" fontWeight="bold" style={{ marginLeft: 40 }}>
              {pageName}
            </Text>
          ) : null}
        </div>

        <div style={{ display: 'flex', flexDirection: 'row', gap: '20px' }}>
          <div
            onClick={handleCollectionButtonClick}
            style={{
              display: 'flex',
              flexDirection: 'row',
              gap: 4,
              padding: '12px 24px',
              alignItems: 'center',
              borderRadius: '22px',
              border: `1px solid ${colorSet.primaryMain}`,
              cursor: 'pointer'
            }}
          >
            <img src={bookmark_primary} alt="" style={{ width: 16, height: 16 }} />
            <Text variant="body2" fontWeight="bold" color={colorSet.primaryMain}>
              컬렉션
            </Text>
          </div>
          <div>
            <img src={profile_circle_primary} style={{ cursor: 'pointer' }} onClick={handlePopoverOpen} />
            <LogoutPopover anchorEl={anchorEl} handlePopoverClose={handlePopoverClose} />
          </div>
        </div>
      </Box>
      <Box style={{ width: '100%', height: styleConstant.menuTopHeight }} />
    </>
  );
};
